import { designState } from "@/store/adventure/designDetails";
import store from "@/store/store";
import { del, get, post, put } from "@/common/authentication/API";

export async function putAdventureStyle(style: any) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend-v2.herokuapp.com/character/AdventureStyle" +
    "?adventure_id=" +
    style.adventureId;
  const data = [style];
  return await put(url, data, config);
}
export async function getAdventureStyle(adventureId: number) {
  const config = {
    headers: {
      Authorization: "Bearer " + store.getters["authToken"],
    },
  };
  const url =
    "https://crescent-backend-v2.herokuapp.com/character/AdventureStyle" +
    "?adventure_id=" +
    adventureId;
  return await get(url, config);
}
